import { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement> & {
  fill?: string;
};

const Wave = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    width="1056"
    height="247"
    viewBox="0 0 1056 247"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M616.751 64.8519C835.916 153.565 1007.83 144.551 1056.15 148.284L1055.97 253.6L1.56078 253.333L0.179625 -8.49149C234.542 -57.0172 357.724 -39.9963 616.751 64.8519Z"
      fill="#EBFDF5"
    />
  </svg>
));

export default Wave;
